import bg_factoring from 'assets/svg/factoring/bg-factoring-incomplete.svg';
import IconRectangle from 'assets/svg/factoring/rectangle.inline.svg';
import IconDollar from 'assets/svg/icons/dollar.inline.svg';
import IconFile from 'assets/svg/icons/file.inline.svg';
import ButtonLink from 'components/Molecules/ButtonLink';
import SEO from 'components/SEO';
import { routes } from 'constants/routes';
import { Link } from 'gatsby';
import React from 'react';
import { css } from 'twin.macro';

const bgFactoring = css`
	height: 42vw;
	position: relative;
	background-image: url(${bg_factoring});
	background-position: center;
	background-repeat: no-repeat;
	background-size: contain;
`;

export default function factoringIncomplete() {
	return (
		<div>
			<SEO
				title='Faktoring niepełny - wszystko co powinieneś wiedzieć / Jak działa faktoring niepełny?'
				description='Najpopularniejszym i zarazem najtańszym rodzajem faktoringiem jest faktoring niepełny inaczej z regresem. Jest to konstrukcja umowna bez przejęcia ryzyka niewypłacalności Twoich odbiorców przez Faktora. W takim wypadku to Faktorant jest odpowiedzialny za wypłacalność swoich kontrahentów. Wówczas, w przypadku braku płatności ze strony odbiorcy w ustalonym, dodatkowym terminie, liczonym od daty wymagalności faktury, Faktorant zobowiązany jest do zwrotu Faktorowi kwoty zaliczki wypłaconej z tytułu wykupu należności. Funkcja finansowa faktoringu niepełnego polega przede wszystkim na skróceniu do minimum terminu płatności (inaczej refinansowaniu) dzięki czemu środki w Twojej firmie pojawiają się natychmiast po wystawieniu faktury i możesz nimi rozporządzać według potrzeby.'
				keywords='faktoring, faktoring niepełny'
				contentType='article'
			/>

			<div css={bgFactoring} className='flex flex-col items-center justify-between pt-30'>
				<IconRectangle width='6.5rem' height='6.5rem' />
			</div>

			<p className='text-center text-20 font-bold mb-30'>Faktoring niepełny</p>

			<div className='px-20 pt-20'>
				<p className='text-16 mb-10'>Faktoring niepełny - definicja</p>
				<p>
					Najpopularniejszym i zarazem najtańszym rodzajem faktoringiem jest faktoring niepełny inaczej z regresem. Jest to konstrukcja umowna bez przejęcia ryzyka niewypłacalności Twoich odbiorców przez Faktora. W takim wypadku to Faktorant jest odpowiedzialny za wypłacalność swoich kontrahentów. Wówczas, w przypadku braku płatności ze strony odbiorcy w ustalonym, dodatkowym terminie, liczonym od daty wymagalności faktury, Faktorant zobowiązany jest do zwrotu Faktorowi kwoty zaliczki wypłaconej z tytułu wykupu należności.
					Funkcja finansowa faktoringu niepełnego polega przede wszystkim na skróceniu do minimum terminu płatności (inaczej refinansowaniu) dzięki czemu środki w Twojej firmie pojawiają się natychmiast po wystawieniu faktury i możesz nimi rozporządzać według potrzeby.
				</p>

				<p className='text-16 mb-10 mt-40'>Faktoring mieszany</p>
				<p>
					Faktoring mieszany stanowi hybrydę posiadającą cechy faktoringu pełnego i niepełnego. Spotykany w przypadku dużych struktur finansowych,
					gdzie możliwe jest ustalenie indywidualnego parytetu ryzyka kredytowego pomiędzy Faktorantem i firmą faktoringową. Umowa faktoringu mieszanego
					zawiera zatem postanowienia charakterystyczne dla faktoringu <Link to={routes.FACTORING_COMPLETE} className='link-in-text'>pełnego</Link> i niepełnego.
				</p>

				<p className='text-16 mb-10 mt-40'>Dla kogo faktoring niepełny</p>
				<p>Konstrukcja limitu faktoringowego sprawia, że jest to wszechstronny i uniwersalny produkt dla każdej firmy.</p>

				<div className='flex items-center mt-03'>
					<div className='bullet'>1</div>
					<p> Jeżeli będąc menadżerem lub właścicielem firmy poszukujesz sposobu na zróżnicowanie sposobów finansowania biznesu, to faktoring niepełny jest właśnie dla Ciebie.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>2</div>
					<p>Jeżeli poszukujesz sposobu na zapewnienie firmie stabilności finansowej, nie ponosząc przy tym żadnych kosztów, to jest produkt właśnie dla Ciebie.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>3</div>
					<p>Jeżeli planujesz dynamiczny rozwój Twojego biznesu i nie chcesz ponosić ryzyka gwałtownego wzrostu i związanej z tym z utratą płynności, to jest produkt właśnie dla Ciebie.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>4</div>
					<p>Jeżeli chcesz kontrolować sytuację w biznesie, a nie być zakładnikiem długów Twojej firmy, to jest produkt dla Ciebie.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>5</div>
					<p>Jeżeli chcesz, aby Twoi klienci nie wykorzystywali swojej dominującej pozycji w relacjach z Twoją firmą, to jest produkt właśnie dla Ciebie.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>6</div>
					<p>Jeśli rozpoczynasz współpracę z nowym klientem i chcesz być pewny, że to dobry wybór, to jest produkt dla Ciebie. </p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>7</div>
					<p>Jeżeli nie chcesz zastawiać całego majątku firmy, to faktoring niepełny może być właśnie dla Ciebie.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>8</div>
					<p>Jeżeli nie chcesz zastawiać Swojego prywatnego majątku, to faktoring niepełny może być właśnie dla Ciebie.</p>
				</div>

				<p className='text-16 mb-10 mt-40'>Zalety faktoringu niepełnego</p>
				<p>
					Faktoring niepełny zaliczany jest do nowoczesnych i innowacyjnych sposobów finansowania bieżącej działalności przedsiębiorstw.
					Funkcja finansowa faktoringu niepełnego polega przede wszystkim na skróceniu do minimum terminu płatności (inaczej refinansowaniu) dzięki czemu środki w Twojej firmie pojawiają się natychmiast po wystawieniu faktury i możesz nimi rozporządzać według potrzeby.
					Jest to szczególnie ważne ze względu na:
				</p>
				<div className='flex items-center mt-03'>
					<div className='bullet'>1</div>
					<p>Utrzymanie stabilności w firmie poprzez ciągłe utrzymanie zdolność pokrycia terminowych, ale także przede wszystkim niespodziewanych wydatków.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>2</div>
					<p>Zmniejszenie presji kontrahentów na ciągłe wydłużanie terminów płatności.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>3</div>
					<p>Poprawa pozycji konkurencyjnej wobec kontrahentów (odbiorców) przy negocjowaniu cen oraz warunków umowy. </p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>4</div>
					<p>Posiadanie rezerwy płynności, która umożliwi wykorzystanie nadarzających się okazji biznesowych (np. zakupu surowców lub towarów  z dużym rabatem za gotówkę czy też zakup innej firmy).</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>5</div>
					<p>Możliwość utrzymania firmy nawet w przypadku wypowiedzenia kredytu bankowego.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>6</div>
					<p>Zróżnicowanie źródeł finansowania firmy.</p>
				</div>

				<p className='mt-20'>
					Zupełnie inaczej w oczach potencjalnego odbiorcy wypada firma, która prosi o skonto (tj. rabat za szybką płatność) za wystawione faktury oraz  firma, która mając zgodę na cesję może elastycznie zarządzać swoją płynnością wykorzystując do tego celu faktoring.
					Jeżeli Twój odbiorca zauważy, że Twoja firma boryka się czasem z dostępem do gotówki, to mogą z tego wyniknąć poważne problemy.
					Po pierwsze z obawy o Twoją zdolność realizacji, odbiorca może ograniczyć zamówienia.
					Po drugie widząc, że jest dla Ciebie  ważnym odbiorcą, może celowo opóźniać zapłatę, lub w ekstremalnych przypadkach nawet ją wstrzymać, aby wynegocjować niższą cenę lub jeszcze dłuższy termin płatności.
					Dodatkowo nie mając do tego pełnej podstawy może obciążyć Ciebie karami umownymi , które następnie potrąci w całości z Twoją fakturą. Wówczas jedynym sposobem odzyskania należności jest spór sądowy, nierzadko trwający latami.
				</p>
				<p className='mt-20'>Wykorzystanie firmy faktoringowej w transakcjach z  Twoimi odbiorcami ma jeszcze jedną ważną zaletę. Otóż zapewni Ci darmowy audyt dokumentów wykorzystywanych w obrocie gospodarczym. Dzięki temu możesz czuć się bezpieczniej, gdy dojdzie do przypadkowego sporu z Twoim odbiorcą. Firma faktoringowa z pewnością zadba, aby Twoja dokumentacja transakcyjna była nie do podważenia w sądzie. Pamiętaj o tym.</p>
				<p className='mt-20'>Podsumowując, <Link to={routes.FACTORING} className='link-in-text'>faktoring</Link> to jeden z najlepszych i najważniejszych instrumentów poprawy płynności finansowej przedsiębiorstw i powinien być w stałym arsenale każdej firmę  działającej w obszarze B2B.</p>
				<div className='flex items-center mt-03'>
					<div className='bullet' />
					<p>Jest zdecydowanie najbezpieczniejszym instrumentem dłużnym porównując go do kredytu czy też pożyczki.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet' />
					<p>Powinien być wykorzystywany w pierwszej kolejności przed kredytem i pożyczką.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet' />
					<p>W odróżnieniu od nich faktoring może stanowić istotną zaporę przed ryzykiem wpadnięcia w spiralę zadłużenia. </p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet' />
					<p>Jest również świetnym testem na rentowność Twojego biznesu. </p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet' />
					<p>Często, jego rola jako jedynego źródła finansowania działalności jest niedoceniana przez przedsiębiorców, głównie ze względu na pozornie skomplikowany charakter takich transakcji.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet' />
					<p>Nie tak dawno zarezerwowany wyłącznie dla dużych firm i tylko w wyspecjalizowanych bankach.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet' />
					<p>Dzisiaj dostępny dla każdego startupu lub firmy rodzinnej.</p>
				</div>

				<p className='text-16 mb-10 mt-40'>Faktoring krajowy</p>
				<p>Ze względu na kryterium geograficzne wyróżniamy faktoring niepełny krajowy i eksportowy. Główna różnica sprowadza się tutaj do dwóch rzeczy. W przypadku faktoringu krajowego Twoi odbiorcy działają w Polsce, a Ty wystawiasz typową fakturę krajową w złotówkach (PLN). Jeżeli jednak zdarzy się sytuacja w której Twój odbiorca chce się rozliczyć w walucie obcej, to sam ten fakt nie przesądza o tym, że jest to faktoring zagraniczny. Mamy tu nadal do czynienia z faktoringiem krajowym. Ważne jest, aby przy tym pamiętać o ryzyku kursowym, które należy zabezpieczyć, o ile wolumen transakcji na to pozwala.</p>

				<p className='text-16 mb-10 mt-40'>Faktoring zagraniczny</p>
				<p>
					W przypadku faktoringu zagranicznego możemy wyróżnić faktoring z dostawą wewnątrzwspólnotową oraz faktoring eksportowy. W przypadku dostaw wewnątrzwspólnotowych Twoi odbiorcy pochodzą z terenu Unii Europejskiej, a walutą rozliczeniową takich transakcji jest zazwyczaj PLN lub EUR.
					W przypadku faktoringu eksportowego dostarczasz towary lub świadczysz usługi dla firm spoza Unii Europejskiej. W takim przypadku walutą rozliczeniową może być niemal dowolna waluta danego kraju, np. GBP, USD, RUB.
					Ważnym aspektem faktoringu zagranicznego jest niemal pewne ryzyko kursowe, które wynika ze zmiany kursów walut powiązanych z PLN.
					W ostatnim czasie doświadczamy dużych zmian na kursie złotego (PLN), co w skrajnym przypadku może nie tylko „zjeść” całą Twoją marżę, ale także wygenerować pokaźną stratę na takiej transakcji.
					Pamiętaj, choć Faktor nie przejmuje na siebie ryzyka kursowego, to może jednak zapewnić Ci  rozliczenia w obcej walucie.
				</p>

				<div className='w-full flex flex-col items-center justify-center'>
					<p className='text-16 mb-10 mt-40'>Jak zacząć?</p>

					<p className='text-center'>Sprawdź indywidualną ofertę dla Ciebie. Możesz to zrobić klikając poniżej.</p>
					<ButtonLink to={routes.OFFERS} primary tw='mt-10 mb-20 bg-accent-3 my-15 mx-auto'>
						<IconDollar/><p>Sprawdź ofertę</p>
					</ButtonLink>

					<p>Następnie złóż wniosek.</p>
					<ButtonLink to={routes.CONCLUSIONS} primary tw='mt-10 mb-20 bg-accent-3 my-15 mx-auto'>
						<IconFile /><p>Złóż wniosek</p>
					</ButtonLink>
				</div>

				<div>
					<p className='contents font-bold'>Pamiętaj:</p> Przed przystąpieniem do wypełniania wniosku przygotuj dane finansowe (za ostatni rok kalendarzowy)
					oraz dane dotyczące zobowiązań Twojej firmy. Dodatkowo zastanów się, jakich odbiorców zgłosisz do wniosku o limit faktoringowy.
					Wykonaj kolejno kroki:
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>1</div>
					<p>Wybierz rodzaj faktoringu: krajowy lub zagraniczny (eksportowy) w walucie.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>2</div>
					<p>Podaj dane wszystkich zgłaszanych odbiorców ( NIP lub nazwę) oraz kwotę sublimitu na każdego z nich.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>3</div>
					<p>W ostatnim kroku podaj wszystkie zobowiązania jakie posiada Twoja firma.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>4</div>
					<p>Sprawdź wstępną decyzję kredytową i wyślij wniosek do analizy przez naszych doradców.</p>
				</div>

				<p className='my-20'>Przygotowanie wniosku zajmie Ci 2 do 5 minut. Decyzja na wniosku jest decyzją wstępną co oznacza, że przed wydaniem końcowej decyzji możemy poprosić Ciebie o dodatkowe dokumenty oraz informacje.</p>
			</div>
		</div>
	);
}
